import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/utils/logger';

interface ManualAiSpendInput {
  functionName: string;
  requestCount?: number;
  entityType?: string;
  displayName?: string;
  metadata?: Record<string, unknown>;
}

/**
 * Record an AI-spending action that was triggered by an operator click.
 *
 * The database gate only guards `system_background_jobs`, so browser-invoked
 * AI calls are otherwise invisible in Observer. This writes a `manual_ui` row
 * into `ai_batch_ledger`. It never blocks the action: a failed ledger write is
 * logged, not thrown.
 */
export async function logManualAiSpend({
  functionName,
  requestCount = 1,
  entityType,
  displayName,
  metadata,
}: ManualAiSpendInput): Promise<void> {
  try {
    const { error } = await supabase.rpc('log_manual_ai_spend', {
      p_function_name: functionName,
      p_request_count: requestCount,
      p_entity_type: entityType ?? null,
      p_display_name: displayName ?? null,
      p_metadata: (metadata ?? {}) as never,
    });

    if (error) {
      logger.error('Failed to record manual AI spend', { functionName, error });
    }
  } catch (error) {
    logger.error('Failed to record manual AI spend', { functionName, error });
  }
}
